import '../styles.css';
import { mountLearnPage } from '../ui/learn/page.js';
import { METHANE_PAGE } from './methane.js';

mountLearnPage(METHANE_PAGE);
